@if (product) {
<div class="flex">
    <!-- image -->
    <a class="m-r image-col"
       [routerLink]="item.url">
        <img [width]="app.client.isS ? 100 : 126"
             [ratio]="1"
             [dfImage]="product.data.image"
             [loaderParams]="{fitIn: item.isGiftCard}">
    </a>
    <!-- details -->
    <div [class.flex-justify-between]="['minibasket'].includes(context)"
         class="w-12 flex-column">
        <div class="flex flex-top flex-justify-between">
            <div>
                <a class="s2 col-1 block m-r-5 m-r-2-s m-r-2-m"
                   [class.col-5]="product.isOutOfStock"
                   [routerLink]="item.url">{{ product?.data?.name }}</a>
                @if (product.data.sku) {
                <p class="col-12 m-t-1"
                   [sizeClass]="'SM:c2, XL:c1'">{{'Product Code:' | translate}}&nbsp;{{product.data.sku}}
                </p>
                }
            </div>

            <p class="flex flex-column-reverse-m flex-column-reverse-s flex-bottom-m flex-bottom-s"
               [tradePricingMask]="[product]">
                @if (item.orgPrice) {
                <price class="col-11 inline-block line-through va-m m-r-1 p2"
                       [value]="item.orgPrice"></price>
                }
                <price class="p2 col-1 inline-block va-m"
                       [value]="item.price"></price>
            </p>

        </div>
        @if(['basket'].includes(context)){
        <div class="flex flex-top flex-column-m flex-column-s m-t-2">
            <product-delivery-state [variant]="'basket'"
                                    [product]="product"
                                    (available)="setAvailble('delivery', $event)"></product-delivery-state>
            <product-collection-state class="block m-l-3 m-l-0-s m-l-0-m m-t-1-m m-t-1-s"
                                      [product]="product"
                                      [variant]="'basket'"
                                      (available)="setAvailble('collection', $event)"></product-collection-state>
        </div>
        }

        <!-- configurable options -->
        <!-- @if (item.configurableOptions?.length && !item.isGiftCard) {
        <p class="c1 col-12 m-t-5">
            @for (option of item.configurableOptions; track $index; let index = $index) {
            @if (index) {
        <div class="vbar m-l-1 m-r-1"></div>
        }
        {{option.value | optionLabel : option.code}}
        }
        </p>
        } -->

        @if (item.isGiftCard) {
        <giftcards-basket-details class="m-t-3"
                                  [request]="item.data.request"></giftcards-basket-details>
        }
        <!-- error handling -->
        @if (warning) {
        <p sizeClass="XL:c1, SM:c2"
           class="col-2 m-t-2">{{warning}}</p>
        }
        <result [status]="status"></result>
        <result [status]="removeStatus"></result>
        <div *ifSize="'XL'"
             class="flex-grow"></div>
        <!-- qty -->
        @if (!hideQty) {
        <div [class.flex]="['minibasket'].includes(context)"
             [class.flex-justify-between]="['minibasket'].includes(context)"
             [sizeClass]="'XL: flex flex-justify-between flex-middle, SM: flex-column-reverse flex-top'"
             class="m-t-2 m-t-0-m m-t-0-s flex">
            <div
                 [ngClass]="['minibasket', 'checkout'].includes(context) ? 'm-t-1 m-t-2-s m-t-2-m flex flex-justify-between-x flex-justify-between-l w-12-x w-12-l' : 'm-t-4-m m-t-4-s'">
                @if (item.qtyEditable) {
                @if (context === 'checkout') {
                <p class="s2 inline-block va-m m-r"
                   cy-basketQtyValue>{{'Qty' | translate}}:&nbsp;{{ data.qty }}</p>
                } @else {
                <basket-item-qty [model]="data.qty || null"
                                 [max]="maxQty > 9999 ? 9999 : maxQty"
                                 [min]="1"
                                 [status]="status"
                                 class="inline-block va-m m-r"
                                 (qtyChange)="setQty($event)"></basket-item-qty>
                }
                }
                @if (context !== 'checkout') {
                <button [buttonStyle]="'inlineButton'"
                        class="va-m "
                        [status]="removeStatus"
                        (click)="remove()"
                        cy-basketRemove>
                    <p class="s2">{{'Remove' | translate}}</p>
                </button>
                }
            </div>
            @if(canSwap){
            <div>
                <button [buttonStyle]="'inlineButton'"
                        [disabled]="swapStatus.busy"
                        [status]="swapStatus"
                        (click)="swap()"
                        class="va-m m-t-2">
                    <p class="s2">{{ (item.data.isCollection === 'false' || !item.data.isCollection ?
                        'Move to collection' : 'Move to delivery') | translate}}
                    </p>
                </button>

            </div>
            }
        </div>
        <result [status]="swapStatus"></result>
        }
    </div>
</div>
}